import {Component} from "react";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import Glob from "../../../libs/Glob.mjs";
import AppUsersIcon from "../../../media/app-images/AppUsersIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import './UserManagement.css'
import {Button, ButtonGroup, Input, InputGroup, InputGroupText} from "reactstrap";
import UserInfoModal from "./UserInfoModal.mjs";
import UserEditModal from "./UserEditModal.mjs";
import AppSettingIcon from "../../../media/app-images/AppSettingIcon.mjs";
import AppRefreshIcon from "../../../media/app-images/AppRefreshIcon.mjs";
import AppCheckboxOnIcon from "../../../media/app-images/AppCheckboxOnIcon.mjs";
import AppCheckboxOffIcon from "../../../media/app-images/AppCheckboxOffIcon.mjs";
import SliderPanel from "../../BaseLayout/SliderPanel.mjs";
import AppAdminIcon from "../../../media/app-images/AppAdminIcon.mjs";
import AppEditIcon from "../../../media/app-images/AppEditIcon.mjs";

const prefix = "UsersManagement";

const UsersManagement = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentUser: Glob.getStatus('userLogin'),
			by: Glob.getPageParam('by'),
			page: Glob.getPageParam('page'),
			ll: Glob.getLanguageLong(),
			ShowNoRoles: !! Glob.getPageParam('ShowNoRoles'),
			pageSize: 10
		}
		this.uid = Glob.generateUid(prefix);
		this.fetchUsers = this.fetchUsers.bind(this);
		this.sortBy = this.sortBy.bind(this);
		this.sort = this.sort.bind(this);
		this.saveUserNotes = this.saveUserNotes.bind(this);
		this.pageNavigation = this.pageNavigation.bind(this);
		this.autoSort = this.autoSort.bind(this);
	}

	componentDidMount() {
		Glob.setStatus('pageTitle', ["Administration",prefix]);
		Glob.setStatus('pageIcon', <AppAdminIcon/>);
		Glob.register('currentPage', this.autoSort, this.uid);
		Glob.register('userPrefs', ()=>{
			const ll = Glob.getLanguageLong();
			if ( ll !== this.state.ll ) this.setState({ ll: ll }, this.fetchUsers );
		}, this.uid)
		setTimeout(this.fetchUsers);
	}

	componentWillUnmount() {
		Glob.deregister(this.uid);
	}

	pageNavigation() {
		const maxPages = this.state.pages;
		if ( ! maxPages || maxPages < 2 ) return null;
		const cp = parseInt(this.state.page);
		const out = [];
		for ( let p = 1; p <= maxPages; p++ ) out.push(p);
		return (
			<div className="pageNavigation">
				{ out.map( p => (
					<div
						key={ p }
						className={ p === cp ? "current" : "active" }
						onClick={ ()=>{
							if ( p !== cp ) Glob.setCurrentPageParam('page', p);
						}}
					>
						{ p }
					</div>
				)) }
			</div>
		)
	}

	async saveUserNotes(u) {
		u.notes = (await appLib.api('admin/user-notes', u)).notes;
		this.setState(
			{userInfo: u, userEdit: undefined },
			this.fetchUsers
		);
	}

	fetchUsers() {
		if ( this.state.resortTimeout ) try { clearTimeout(this.state.resortTimeout); } catch ( e ) {}
		this.setState({ loading: true, resortTimeout: false }, async () => {
			const list = (await appLib.api('admin/user-list', {}))?.list || [];
			let countDisabled = 0;
			for ( let i = 0; i < list.length; i++ ) {
				if ( list[i].lastRoles ) {
					list[i].lastRoles = (list[i].lastRoles||[]).join(', ');
				} else {
					list[i].lastRoles = '—';
					countDisabled++;
				}
			}
			//console.log("usersList", list);
			this.setState({list: list, countDisabled: countDisabled }, this.sort);
		});
	}

	autoSort( cp ) {
		if ( ! cp ) cp = Glob.getCurrentPage();
		const ns = { ShowNoRoles: !! cp.params.ShowNoRoles };
		if (cp.params.by !== this.state.by) ns.by = cp.params.by;
		if (cp.params.page !== this.state.page) ns.page = cp.params.page;
		if (cp.params.pageSize && parseInt(cp.params.pageSize) !== this.state.pageSize) ns.pageSize = parseInt(cp.params.pageSize);
		if (cp.params.filter !== this.state.filter) ns.filter = cp.params.filter;
		if ( this.state.resortTimeout ) {
			try { clearTimeout(this.state.resortTimeout); } catch ( e ) {}
			ns.resortTimeout = false;
		}
		this.setState(ns, this.sort);
	}

	sortBy(axle) {
		if ( axle === 'username') axle = undefined;
		if ( axle === this.state.by ) return;
		if ( axle ) {
			Glob.setCurrentPageParam('by', axle);
		} else {
			Glob.rmCurrentPageParam('by' );
		}
	}

	sort() {
		if ( this.state.resortTimeout ) try { clearTimeout(this.state.resortTimeout); } catch ( e ) {}
		const by = this.state.by || 'username';
		const currentPage = Number(this.state.page ?? 1);
		let page = currentPage;
		let range = structuredClone(this.state.list || []);
		if ( ! this.state.ShowNoRoles ) {
			range = range.filter(u => u.lastRoles.length > 1 );
		}
		if (this.state.filter) {
			range = range.filter(u => u.username.includes(this.state.filter));
		}
		const pages = Math.ceil(range.length / this.state.pageSize);
		range.sort((a, b) => a.username.toLowerCase().localeCompare(b.username.toLowerCase()))
		switch (by) {
			case 'lastActivity':
				range.sort((a, b) => ((a.lastActivity || 0) < (b.lastActivity || 0) ? 1 : -1));
				break;
			case 'lastRoles':
				range.sort((a, b) => a.lastRoles.localeCompare(b.lastRoles));
				break;
			default:
				break;
		}
		if ((page -1) * this.state.pageSize > range.length) page = 1;
		range = range.slice((page - 1) * this.state.pageSize, page * this.state.pageSize);
		this.setState(
			{
				range: range,
				by: by,
				page: String(page),
				pages: pages,
				loading: false,
			},
			() => {
				if (page !== currentPage) Glob.setCurrentPageParam('page', String(page));
			}
		);
	}

	render() {
		/*
			state:
			- list: the full list of users from server
			- range: the window of users to be shown
		 */
		if (!this.state.range) return null;
		const now = Date.now();
		return (
			<SliderPanel
				title={<TextLabel value={"UsersManagement"}/>}
				icon={<AppUsersIcon/>}
				className={prefix}
			>
				<div className={"content limited"}>
					<div className={"control-buttons"}>
						{ ( !! this.state.countDisabled ) && (
							<InputGroupText
								style={{cursor: "pointer"}}
								className={"clickable mb-1"}
								onClick={() => {
									if ( this.state.ShowNoRoles ) {
										Glob.rmCurrentPageParam('ShowNoRoles');
									} else {
										Glob.setCurrentPageParam('ShowNoRoles', 'true');
									}
								}}
							>
								{ this.state.ShowNoRoles ? <AppCheckboxOnIcon /> : <AppCheckboxOffIcon /> }
								<TextLabel value={"ShowNoRolesExtended"} /> ({this.state.countDisabled})
							</InputGroupText>
						)}
						<InputGroup>
							<Input
								type="text"
								value={ this.state.filter || ''}
								onChange={ e => {
									this.setState({ filter: e.target.value }, this.sort);
								}}
								placeholder={ Glob.label('Filter') }
							/>
							<InputGroupText>
								<ButtonGroup
									className="btn-icon"
								>
									<Button
										disabled={ !! this.state.loading }
										onClick={ this.fetchUsers }
										color={"primary"}
									>
										<b>
											<TextLabel value={"Reload"}/>
										</b>
										<i>
											<AppRefreshIcon />
										</i>
									</Button>
								</ButtonGroup>
							</InputGroupText>
						</InputGroup>
					</div>
					{(this.state.range.length > 0) && (
						<div className={"table-container"}>
							{ this.pageNavigation() }
							<table className={"user-list"} cellSpacing={0} cellPadding={0} border={0}>
								<thead>
								<tr>
									<th
										role={"button"}
										onClick={() => { this.sortBy('username') }}
										className={this.state.by === 'username' ? 'active' : ''}
									>
										<span>
											<TextLabel value={"Username"}/>
										</span>
									</th>
									<th
										role={"button"}
										onClick={() => { this.sortBy('lastActivity') }}
										className={this.state.by === 'lastActivity' ? 'active' : 'no-mobile'}
									>
										<span>
											<TextLabel value={"LastSeen"}/>
										</span>
									</th>
									<th
										role={"button"}
										onClick={() => { this.sortBy('lastRoles') }}
										className={this.state.by === 'lastRoles' ? 'active' : 'no-mobile'}
									>
										<span>
											<TextLabel value={"Roles"}/>
										</span>
									</th>
									<th>
										<span />
									</th>
								</tr>
								</thead>
								<tbody>
								{ this.state.range.map( (user) => (
									<tr key={user.username}>
										<td>
											{ (!! user.notes) && <span title={user.notes}><AppEditIcon /></span> }
											{user.username}
										</td>
										<td className={"no-mobile"}>
											{ user.lastSeen ?
												(
													(now - user.lastSeen < 20000) ?
														<TextLabel value={"Now"} /> :
														(new Date(user.lastSeen)).toLocaleString(this.state.ll)
												) :
												<TextLabel value={"Never"} />
											}
										</td>
										<td>
											{ user.lastRoles }
										</td>
										<td>
											<span onClick={() => { this.setState({ userInfo: user }); }}>
												<AppSettingIcon/>
											</span>
										</td>
									</tr>
								))}
								</tbody>
							</table>
						</div>
					)}
				</div>
				{ this.state.userInfo && (
					<UserInfoModal
						close={ ()=>{ this.setState({ userInfo: undefined })} }
						edit={
							this.state.userInfo?.username === this.state.currentUser.username ?
								undefined :
								() => {
									const u = structuredClone(this.state.userInfo);
									this.setState({ userInfo: undefined, userEdit: u });
								}
						}
						user={ this.state.userInfo }
					/>
				)}
				{ this.state.userEdit && (
					<UserEditModal
						close={ ()=> {
							const u = structuredClone(this.state.userEdit);
							this.setState({ userEdit: undefined, userInfo: u });
						} }
						save={ this.saveUserNotes }
						user={ this.state.userEdit }
					/>
				)}
			</SliderPanel>
		)
	}
}

export default UsersManagement;
